<template>
  <div class="modal mymodal" :id="modalid" tabindex="-1" :aria-labelledby="modalid + 'Label'" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header" style='background: #9999FF;padding:2px'>
          <p class="modal-title">SwapExec on swap {{swapid}}</p>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <h5>{{script}}</h5>
          <label style='padding=20px' for="myinp01">ARG: </label>
          <input id="myinp01" type="text" v-model="argument">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.mymodal > div {
    position: absolute ;
    background-color: yellow;
}
.nomargin {
   margin-block-start: 0 ;
   margin-block-end : 0 ;
}
</style>

<script>
export default {
  name: 'ShowModal',
  props: {
    swapid : String,
    script : String,
    modalid : String
  },
  methods : {
  },
  data() {
    return {
      argument : "nothing" 
    }
  }
}
</script>
